// Use is getNested({test: {foo: 33 }}, "test.foo")
export default (stack, needle = '', defaultValue: any = null) =>
  needle.split('.').reduce((xs, x) => (xs && typeof xs[x] !== 'undefined' ? xs[x] : defaultValue), stack);
